<template>
  <v-dialog
    :fullscreen="$vuetify.breakpoint.smAndDown"
    v-model="dialog"
    @keydown.esc="cancel"
    :max-width="$vuetify.breakpoint.smAndDown ? 'none' : '600px'"
    content-class="fullscreen-dialog"
    persistent
  >
    <v-card class="dialog-card">
      <v-toolbar color="primary" dense class="header primaryText--text">
        <v-row>
          <v-col cols="2">
            <v-btn text @click="cancel">{{ $t("cancel") }}</v-btn>
          </v-col>

          <v-col cols="8" class="d-flex justify-center">
            <div>
              <v-toolbar-title
                class="header-title1"
                v-if="$store.state.store != null && $store.state.store.info != null"
                >{{ $store.getters.storeName }}</v-toolbar-title
              >
              <v-toolbar-title class="header-title2">{{ $t("profile") }}</v-toolbar-title>
            </div>
          </v-col>

          <v-col cols="2" align-self="end" style="text-align:right">
            <v-btn text v-show="valid" @click="save">{{ $t("save") }}</v-btn>
          </v-col>
        </v-row>
      </v-toolbar>

      <v-form v-model="valid" ref="form">
        <v-container>
          <v-list-item>
            <v-text-field readonly v-model="memberCode" :label="$t('member_code')"></v-text-field>
          </v-list-item>
          <v-list-item>
            <v-text-field
              v-model="firstname"
              :rules="[inputRules.required]"
              :label="$t('firstname')"
              required
            ></v-text-field>
          </v-list-item>
          <v-list-item>
            <v-text-field
              v-model="lastname"
              :rules="[inputRules.required]"
              :label="$t('lastname')"
              required
            ></v-text-field>
          </v-list-item>

          <v-list-item>
            <v-text-field readonly v-model="phoneId" :label="$t('phone_no')"></v-text-field>
          </v-list-item>
          <v-list-item>
            <v-text-field v-model="email" :rules="[inputRules.emailOpt]" :label="$t('email')"></v-text-field>
          </v-list-item>
          <v-list-item>
            <v-select v-model="monthOfBirth" :items="months" :label="$t('month_of_birth')"></v-select>
          </v-list-item>
          <v-list-item>
            <v-switch color="secondary" v-model="vip" :label="$t('member_vip')" readonly></v-switch>
          </v-list-item>
          <div v-if="member != null">
            <!--             
            <v-list-item>
              <v-switch color="secondary" v-model="smsNews" label="sms news"></v-switch>
            </v-list-item> 
            -->
            <v-list-item>
              <v-switch color="secondary" v-model="smsPromo" :label="$t('sms_receive_promo')"></v-switch>
            </v-list-item>
          </div>
        </v-container>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  data: () => ({
    dialog: false,
    resolve: null,
    reject: null,

    valid: false,

    member: {},
    memberCode: "",
    firstname: "",
    lastname: "",
    phoneId: "",
    email: "",
    monthOfBirth: "",
    smsNews: false,
    smsPromo: false,
    vip: false,

    months: [
      "",
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ],
  }),

  created() {},

  mounted() {},

  computed: {},

  methods: {
    open(member) {
      this.dialog = true;

      this.memberCode = "";
      this.firstname = "";
      this.lastname = "";
      this.email = "";
      this.phoneId = "";
      this.monthOfBirth = "";
      this.smsNews = false;
      this.smsPromo = false;
      this.vip = false;

      if (member == null && this.$appMode == 1) member = this.$store.state.member;

      if (member != null) {
        this.member = member;

        if (member.MemberCode != "") this.memberCode = member.MemberCode;
        if (member.MemberFirstName != "") this.firstname = member.MemberFirstName;
        if (member.MemberLastName != "") this.lastname = member.MemberLastName;
        if (member.phoneId != "") this.phoneId = member.PhoneId;
        if (member.MemberEMail != "") this.email = member.MemberEMail;
        if (member.MonthOfBirth >= 1 && member.MonthOfBirth <= 12) this.monthOfBirth = this.months[member.MonthOfBirth];

        if (member != null) {
          this.smsNews = member.SmsNews;
          this.smsPromo = member.SmsPromo;

          if (member.MemberMetadata != null) {
            if (member.MemberMetadata.MemberExVIP != null) {
              this.vip = member.MemberMetadata.MemberExVIP;
            }
          }
        }
      }
      //console.log(this.member);

      return new Promise((resolve, reject) => {
        this.resolve = resolve;
        this.reject = reject;
      });
    },

    save() {
      this.$set(this.member, "MemberFirstName", this.firstname);
      this.$set(this.member, "MemberLastName", this.lastname);
      this.$set(this.member, "MemberEMail", this.email);
      this.$set(this.member, "MonthOfBirth", this.months.indexOf(this.monthOfBirth));
      if (this.member != null) {
        this.$set(this.member, "SmsNews", this.smsNews);
        this.$set(this.member, "SmsPromo", this.smsPromo);
      }

      //console.log(this.member);

      this.rest_putMember(this.member).then(memberResp => {
        console.log(memberResp);
        if (memberResp.result == "ok") {
          this.close(true);
        } else {
          this.$root.messageDialog(this.$t("error_alert_title"), "", memberResp.result);
        }
      });
    },

    close(result) {
      this.reset();
      this.dialog = false;
      this.resolve(result);
    },

    cancel() {
      this.close(null);
    },

    reset() {
      this.$refs.form.reset();
    },
  },
};
</script>

<style lang="scss" scoped></style>
